// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ion-item {\n  --background: transparent;\n  --border-style: none !important;\n}", "",{"version":3,"sources":["webpack://./src/app/pages/vip/vip.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACH,+BAAA;AACD","sourcesContent":["ion-item{\n    --background: transparent;\n\t--border-style: none !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
